import React, { useEffect, ReactNode } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  // Navigate,
  useLocation,
} from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
// import { useGeneralStore } from 'src/store';
// import { useQuery } from 'src/utils';
import { useAuthInitialization } from 'src/hooks/useAuthInitialization';
import SessionExpiredModal from '@components/shared/session-expired-modal/SessionExpiredModal';

import LoginPage from '@pages/LoginPage';
import ForgotPasswordPage from '@pages/ForgotPasswordPage';
import ResetPasswordPage from '@pages/ResetPasswordPage';
import RegistrationPage from '@pages/RegistrationPage';
import OnBoarding from '@pages/OnBoarding';
import ThankYou from '@pages/ThankYou';
import { TesterPage } from '@pages/TesterPage';
// import { TesterPagePayment } from '@pages/TesterPagePayment';
import NotFoundPage from '@pages/NotFoundPage';

import { PublicLayout } from 'src/layouts/PublicLayout';
import { PrivateLayout } from 'src/layouts/PrivateLayout';
import { ProfileLayout } from 'src/layouts/ProfileLayout';
import ProfilePage from '@pages/Profile';
import {
  HomePage,
  ProfilePage as ProfileInnerPage,
  YourPlansPage,
  BillingPage,
  ResourcesPage,
  IDCards,
  IDCardView,
} from 'src/features/profile/pages';

const queryClient = new QueryClient();

interface BrandInitializerProps {
  children: ReactNode;
}

const BrandInitializer: React.FC<BrandInitializerProps> = ({ children }) => {
  return <>{children}</>;
};

interface AuthInitializerProps {
  children: ReactNode;
}

const AuthInitializer: React.FC<AuthInitializerProps> = ({ children }) => {
  useAuthInitialization();
  return <>{children}</>;
};
export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);

  return null;
};
const AppRouter: React.FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <ScrollToTop />
        <AuthInitializer>
          <BrandInitializer>
            <SessionExpiredModal />
            <Routes>
              {/* Публичная часть */}
              <Route element={<PublicLayout />}>
                <Route path="/login" element={<LoginPage />} />
                <Route
                  path="/forgot-password"
                  element={<ForgotPasswordPage />}
                />
                <Route path="/reset-password" element={<ResetPasswordPage />} />
                <Route path="/registration" element={<RegistrationPage />} />
              </Route>

              {/* Приватная часть */}
              <Route element={<PrivateLayout />}>
                <Route path="/" element={<OnBoarding />} />
                <Route path="/thanks" element={<ThankYou />} />
                <Route path="/tester" element={<TesterPage />} />
                {/* <Route path="/payment" element={<TesterPagePayment />} /> */}
              </Route>

              {/* Профиль с отдельным лейаутом */}
              <Route element={<ProfileLayout />}>
                <Route path="/healthhub" element={<ProfilePage />}>
                  <Route index element={<HomePage />} />
                  <Route path="profile" element={<ProfileInnerPage />} />
                  <Route path="your-plans" element={<YourPlansPage />} />
                  <Route path="billing" element={<BillingPage />} />
                  <Route path="resources" element={<ResourcesPage />} />
                  <Route path="id-cards" element={<IDCards />} />
                  <Route
                    path="id-cards/:subscriptionId/:applicantId"
                    element={<IDCardView />}
                  />
                </Route>
              </Route>

              {/* 404 fallback */}
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </BrandInitializer>
        </AuthInitializer>
      </Router>
    </QueryClientProvider>
  );
};

export default AppRouter;
